module.exports = __webpack_public_path__ + "img/default-disembark.3e748930.png";